"use client";

import { routes } from "../../../../config/routes";
import AvatarCard from "@core/ui/avatar-card";
import DateCell from "@core/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Text, Flex } from "rizzui";
// import TableRowActionGroup from "../../table-row-action-group";
import { Campaign } from "packages/app/src/types";
import { MoreActions } from "../../../../components/table-utils/campaign-more-actions";
import { suspendCampaign } from "../../../api/suspend-campaign";

function formatCurrency(amount: number, code: string) {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })} ${code}`;
  }
}

const columnHelper = createColumnHelper<Campaign>();

export const campaignListColumns = [
  // columnHelper.display({
  //   id: "actions",
  //   header: "Actions",
  //   size: 80,
  //   cell: ({ row, table: { options } }) => (
  //     <TableRowActionGroup
  //       viewUrl={routes.campaignManagement.details(row.original._id)}
  //       onDelete={() => options.meta?.handleDeleteRow?.(row.original)}
  //     />
  //   ),
  // }),
  columnHelper.accessor("campaignId", {
    header: "Campaign ID",
    size: 200,
    cell: (info) => (
      <Text className="text-sm font-medium">{info.getValue()}</Text>
    ),
  }),

  columnHelper.accessor("title", {
    header: "Title",
    size: 350,
    enableSorting: true,
    cell: (info) => (
      <AvatarCard
        src={info.row.original.campaignImage}
        name={info.getValue()}
        description={info.row.original.reason}
      />
    ),
  }),

  columnHelper.accessor((row) => row.user.email, {
    id: "email",
    header: "Creator Email",
    size: 280,
    cell: (info) => info.getValue().toLowerCase(),
  }),

  columnHelper.accessor("amountNeeded", {
    header: "Goal",
    size: 160,
    cell: (info) => {
      const amount = info.getValue();
      const curr = info.row.original.currencyType;
      return (
        <Text className="text-sm font-medium text-green-600">
          {formatCurrency(amount, curr)}
        </Text>
      );
    },
  }),

  columnHelper.accessor("amountRaised", {
    header: "Raised",
    size: 160,
    cell: (info) => {
      const amount = info.getValue();
      const curr = info.row.original.currencyType;
      return (
        <Text className="text-sm font-medium text-blue-600">
          {formatCurrency(amount, curr)}
        </Text>
      );
    },
  }),

  columnHelper.accessor("createdAt", {
    header: "Created On",
    size: 200,
    cell: (info) => <DateCell date={new Date(info.getValue())} />,
  }),
  columnHelper.accessor("_id", {
    id: "actions",
    header: "",
    size: 100,
    enableSorting: false,
    cell: ({ row, table: { options } }) => (
      <Flex align="center" justify="end" gap="3">
        <MoreActions
          id={row.original._id}
          onSuspend={async (reason: string) => {
            try {
              await suspendCampaign(row.original.campaignId, reason);
              // remeber to update status when Ope adds status:
              // options.meta?.updateRow?.(row.index, { status: "suspended" })
            } catch (error) {
              console.log('Error suspending campaign', error)
            }
          }}
          onDelete={() => options.meta?.handleDeleteRow?.(row.original)}
        />
      </Flex>
    ),
  }),
];